import { NgxSpinner, NgxSpinnerService, PRIMARY_SPINNER, Spinner } from 'ngx-spinner';
import { Injectable } from '@angular/core';

export const MGP_SPINNER_DEFAULTS = {
    BD_COLOR: 'rgba(255, 255, 255, 0.5)',
    SPINNER_COLOR: '#F02624',
    SPINNER_TYPE: 'timer',
    SPINNER_SIZE: 'medium'
};

@Injectable({providedIn: 'root'})
export class MgpSpinnerService extends NgxSpinnerService {

    constructor() {
        super();
    }

    show(name: string = PRIMARY_SPINNER, spinner?: Spinner): Promise<any> {
        if (spinner && Object.keys(spinner).length) {
            spinner.bdColor =  spinner.bdColor ?? MGP_SPINNER_DEFAULTS.BD_COLOR;
            spinner.color = spinner.color ?? MGP_SPINNER_DEFAULTS.SPINNER_COLOR;
            spinner.type = spinner.type ?? MGP_SPINNER_DEFAULTS.SPINNER_TYPE;
            spinner.size = spinner.size ?? "medium";
            spinner.zIndex =  999;
        } else {
            spinner = {
                name,
                bdColor: MGP_SPINNER_DEFAULTS.BD_COLOR,
                color: MGP_SPINNER_DEFAULTS.SPINNER_COLOR,
                type: MGP_SPINNER_DEFAULTS.SPINNER_TYPE,
                size: MGP_SPINNER_DEFAULTS.SPINNER_SIZE,
                zIndex: 999,
                show: true
            } as Partial<NgxSpinner>;
        }

        return super.show(name, spinner);    
    }
}